import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import useLanguage from '../hooks/useLanguage';

const { FiBookOpen } = FiIcons;

const Footer = () => {
  const { t } = useLanguage();

  const handleTikTokClick = () => {
    window.open('https://www.tiktok.com/@alfredmenendez', '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.footer 
      className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 py-8 sm:py-12"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-8">
        <div className="flex flex-col items-center space-y-4 sm:space-y-6">
          <motion.div 
            className="flex items-center space-x-2 sm:space-x-3"
            whileHover={{ scale: 1.02 }}
            transition={{ type: "spring", stiffness: 400 }}
          >
            <div className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg sm:rounded-xl flex items-center justify-center shadow-lg flex-shrink-0">
              <SafeIcon icon={FiBookOpen} className="text-white text-lg sm:text-xl" />
            </div>
            <div className="text-center">
              <h3 className="text-base sm:text-xl font-bold text-gray-900 dark:text-white flex items-center flex-wrap justify-center">
                <span>{t('title')}</span>
                <span className="mx-2 text-gray-300 dark:text-gray-600 font-light">|</span>
                <span className="text-sm sm:text-base font-normal text-gray-600 dark:text-gray-400">
                  {t('footerAppBy')}{' '}
                  <a 
                    href="https://appfred.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="font-extrabold bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent hover:opacity-80 transition-opacity duration-200"
                    style={{ 
                      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif"
                    }}
                  >
                    Appfred
                  </a>
                </span>
              </h3>
            </div>
          </motion.div>

          <div className="text-center space-y-1 sm:space-y-2">
            <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
              {t('copyright')}
            </p>
            <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
              {t('footerSubtitle')}
            </p>
          </div>

          <motion.button
            onClick={handleTikTokClick}
            className="p-2.5 sm:p-3 bg-gray-900 dark:bg-gray-700 hover:bg-gray-800 dark:hover:bg-gray-600 text-white rounded-lg sm:rounded-xl transition-all duration-200"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            title={t('followUs')}
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
            </svg>
          </motion.button>

          <div className="text-center text-xs sm:text-sm text-gray-400 dark:text-gray-500 max-w-2xl space-y-1">
            <p>
              {t('footerDescription')}
            </p>
          </div>
        </div>
      </div>
    </motion.footer>
  );
};

export default Footer;